var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "227.795 50.211 114.767 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.395 67.5996V144.111H279.962V67.5996H290.395ZM279.962 57.1663C274.202 57.1663 269.528 61.8395 269.528 67.5996V144.111C269.528 149.871 274.202 154.544 279.962 154.544H290.395C296.155 154.544 300.828 149.871 300.828 144.111V67.5996C300.828 61.8395 296.155 57.1663 290.395 57.1663H279.962ZM248.662 109.333V144.111H238.228V109.333H248.662ZM238.228 98.8997C232.468 98.8997 227.795 103.573 227.795 109.333V144.111C227.795 149.871 232.468 154.544 238.228 154.544H248.662C254.422 154.544 259.095 149.871 259.095 144.111V109.333C259.095 103.573 254.422 98.8997 248.662 98.8997H238.228ZM321.695 81.5108H332.129V144.111H321.695V81.5108ZM311.262 81.5108V144.111C311.262 149.871 315.935 154.544 321.695 154.544H332.129C337.889 154.544 342.562 149.871 342.562 144.111V81.5108C342.562 75.7507 337.889 71.0774 332.129 71.0774H321.695C315.935 71.0774 311.262 75.7507 311.262 81.5108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsInactive);
export default __webpack_public_path__ + "static/media/reports-inactive.091558becab19800ad27f8cdc7b0b079.svg";
export { ForwardRef as ReactComponent };